module.exports = __webpack_public_path__ + "img/1.547fb27b.png";